const DefaultConfiguration = {
    /**
   * postType is the post type, duh.
   */
    postType: 'post',

    /**
   * appClass is the className that will be applied to the root component
   */
    appClass: 'post-grid-react',

    /**
   * searchPlaceholder is the placeholder text in the text search field
   */
    searchPlaceholder: 'Search',

    /**
   * noResultsText is the text displayed when the filter gets back nothing
   */
    noResultsText: 'No results found. Please try different search terms.',

    /**
   * pageLength is the number of items per "page"
   */
    pageLength: 9
};

export default DefaultConfiguration;



// WEBPACK FOOTER //
// ./wp-content/themes/gwy/assets/scripts/source/vpm/post-grid/config.js